// 入口文件main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
// 导入全局样式表
import './assets/fonts/iconfont.css'
import './assets/css/index.less'
import Vant from 'vant';
import 'vant/lib/index.css';
import httpRequest from './utils/httpRequest'
import { getTokenParamsObj,getTokenPath } from './utils/index'

let Base64 = require('js-base64').Base64 // api: https://github.com/axios/axios
Vue.use(Vant);
Vue.config.ignoredElements = [
  'wx-open-launch-weapp', 
]

httpRequest.defaults.baseURL = '/api'
Vue.prototype.$http = httpRequest
Vue.config.productionTip = false

async function getTK(){
  await Vue.prototype.$http({
    url: getTokenPath(),
    data: getTokenParamsObj(),
    method: "post",
  }).then(({ data }) => {
    console.log('成功获取Token')
    this.$store.commit("updateToken", data.data.token);
    return true
  });
}
Vue.prototype.getTK = getTK


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


